/**
 * Combined Shopify Help Center Script 
 * Updated to handle Footer Link clicks via Hash Change
 */

const sideNav = document.getElementById('side-navigation');
const footerStop = document.getElementById('footer-stop');
const mainWrapper = document.getElementById('main-wrapper');
const stickyTopMargin = 120; 
const STICKY_START_SCROLL = 150; 

let stopScrollPoint = 0;
let absolutePinTop = 0;

function calculatePositions() {
    if (!sideNav || !footerStop || !mainWrapper) return;
    sideNav.classList.remove('sticky-nav', 'absolute-pinned');
    sideNav.style.position = '';
    sideNav.style.top = '';
    sideNav.style.width = ''; 

    const sideNavHeight = sideNav.offsetHeight;
    const footerTopOffset = footerStop.offsetTop;
    const mainWrapperHeight = mainWrapper.offsetHeight;

    stopScrollPoint = footerTopOffset - sideNavHeight - stickyTopMargin;
    absolutePinTop = mainWrapperHeight - sideNavHeight; 
}

function handleScroll() {
    if (!sideNav) return;
    const scrollY = window.scrollY;
    const parentWidth = sideNav.parentElement.offsetWidth;

    if (scrollY < STICKY_START_SCROLL) {
        sideNav.classList.remove('sticky-nav', 'absolute-pinned');
        sideNav.style.position = '';
        sideNav.style.top = '';
    } else if (scrollY >= stopScrollPoint) {
        sideNav.classList.remove('sticky-nav');
        sideNav.classList.add('absolute-pinned');
        sideNav.style.top = `${absolutePinTop}px`;
        sideNav.style.position = 'absolute';
    } else {
        sideNav.classList.remove('absolute-pinned');
        sideNav.classList.add('sticky-nav');
        sideNav.style.width = `${parentWidth}px`; 
        sideNav.style.position = 'fixed';
        sideNav.style.top = `${stickyTopMargin}px`;
    }
}

/**
 * NEW: The Core Tab-Switching Logic
 * Extracted so it can be called from both Clicks and Hash Changes
 */
function switchToTab(targetId) {
    const tabs = document.querySelectorAll(".help-center__side-tab-item a");
    const sections = document.querySelectorAll(".faq, .shipping-policy, .return-policy, .accessibility, .privacy, .terms-and-service");
    const targetSection = document.getElementById(targetId);
    const targetTab = document.querySelector(`.help-center__side-tab-item a[href="#${targetId}"]`);

    if (!tabs.length) return; // help-center pages only - wag hijack ang LP anchor links
    if (!targetSection) return;

    // 1. Reset all
    tabs.forEach(t => {
        t.classList.remove("active");
        t.setAttribute("aria-selected", "false");
    });
    sections.forEach(s => {
        s.classList.remove("active");
        s.setAttribute("aria-hidden", "true");
    });

    // 2. Activate target
    if (targetTab) {
        targetTab.classList.add("active");
        targetTab.setAttribute("aria-selected", "true");
    }
    targetSection.classList.add("active");
    targetSection.setAttribute("aria-hidden", "false");

    // 3. Recalculate and Scroll
    calculatePositions();
    
    setTimeout(() => {
        const scrollPosition = targetSection.offsetTop - stickyTopMargin;
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        handleScroll();
    }, 50);
}

document.addEventListener("DOMContentLoaded", () => {
    // Listen for Side Nav clicks
    const tabs = document.querySelectorAll(".help-center__side-tab-item a");
    tabs.forEach(tab => {
        tab.addEventListener("click", (e) => {
            const targetId = tab.getAttribute("href")?.replace("#", "");
            // Let the hashchange listener handle the rest to keep it synced
            // If the hash is already the same, manually trigger
            if (window.location.hash === `#${targetId}`) {
                switchToTab(targetId);
            }
        });
    });

    // --- THE FIX: Listen for ANY hash change (Footer links, etc.) ---
    window.addEventListener("hashchange", () => {
        const newHash = window.location.hash.replace("#", "");
        if (newHash) {
            switchToTab(newHash);
        }
    });

    // Initial Load Check
    const initialHash = window.location.hash.replace("#", "");
    if (initialHash) {
        switchToTab(initialHash);
    } else {
        // Default to FAQ if no hash
        switchToTab('faq'); 
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', () => {
        setTimeout(() => { calculatePositions(); handleScroll(); }, 200);
    });
});